import styled from '@emotion/styled'

const FeedTopBarClearfix = styled.div`
  height: 90px;
  width: 100%;
`

export { FeedTopBarClearfix }
